export default __webpack_public_path__ + "static/top3-8cd3459e392c5510d3059f117ee6db2a.jpeg";